import { Box, Flex, StyleSystemProps, styled, defaultTheme } from '@withjoy/joykit';
import { VariantType } from './CategoryShowcase';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledContainer = styled(Box)``;
export const StyledNavLink = styled(Flex)``;
export const StyledElementTitle = styled(Box)`
  font-weight: 600;
`;
export const StyledElementTitleHover = styled(Box)``;
export const StyledElementLayer = styled(Box)``;
export const StyledElementImage = styled(Box)``;
export const StyledElementContainer = styled(Box)`
  @media (hover: hover) {
    :hover {
      ${StyledElementImage} {
        transform: scale(1.1);
      }
    }
  }
`;

const containerStyles: StyleSystemProps = {
  overflow: 'hidden'
};

const navLinkStyles: StyleSystemProps = {
  justifyContent: 'center'
};

const elementContainerStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  position: 'relative',
  borderRadius: 3,
  overflow: 'hidden'
};

const elementLogoContainerStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  position: 'relative',
  borderRadius: 3,
  overflow: 'hidden',
  backgroundColor: '#fff',
  border: `1px solid ${defaultTheme.colors.mono3}`,
  boxShadow: '0px 9px 36px -30px rgba(0, 0, 0, 0.04), 0px 10px 60px -20px rgba(44, 41, 37, 0.03),  0px 3px 8px 0px rgba(0, 0, 0, 0.03)'
};

const elementTitleStyles = (variant: VariantType): StyleSystemProps => ({
  bottom: '50%',
  color: 'white',
  position: 'absolute',
  transform: 'translateY(50%)',
  whiteSpace: 'break-spaces',
  paddingX: 6,
  textAlign: 'center',
  zIndex: 3,
  transition: animationTransition('opacity')
});

const elementTitleHoverStyles: StyleSystemProps = {
  bottom: '50%',
  transform: 'translateY(50%)',
  color: 'white',
  zIndex: 2,
  position: 'absolute',
  border: '2px solid white',
  paddingX: 5,
  paddingY: 3,
  borderRadius: 2,
  transition: animationTransition('opacity')
};

const elementLayerStyles = (background: string, backgroundActive: string): StyleSystemProps => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background,
  borderRadius: 3,
  zIndex: 1,
  _active: {
    background: backgroundActive
  }
});

const elementImageStyles = (paddingTop: string): StyleSystemProps => ({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  flexGrow: 1,
  width: '100%',
  height: '100%',
  paddingTop,
  transition: animationTransition('transform')
});

const elementLogoStyles = (paddingTop: string): StyleSystemProps => ({
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  flexGrow: 1,
  width: '100%',
  height: '100%',
  paddingTop,
  transition: animationTransition('transform'),
  transform: 'scale(0.8)'
});

export const styles = {
  container: containerStyles,
  navLink: navLinkStyles,
  elementContainer: elementContainerStyles,
  elementTitle: elementTitleStyles,
  elementTitleHover: elementTitleHoverStyles,
  elementLayer: elementLayerStyles,
  elementImage: elementImageStyles,
  elementLogo: elementLogoStyles,
  elementLogoContainer: elementLogoContainerStyles
};
